module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-title-sp_5570a70cbccaed28b680d926dc3fa0c7.png";